import React, { useState } from 'react';
import { TextInput, View, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const CustomSearchBar = ({ value, onChangeText, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <View
      style={{
        borderColor: isFocused ? '#FFB52E' : '#653463', // Change these colors
        borderWidth: 1.5,
        width: '60%',
        minWidth: 240,
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: 'transparent',
        borderRadius: 25,
        marginTop: 10,
        overflow: 'visible',
        // Add other styles as needed
      }}
    >   
        <View style={{ position: 'absolute',  justifyContent: 'center', paddingStart: 15 }}>
            <Ionicons name="search" size={18} color="#653463" />
        </View>

        <TextInput
            value={value}
            onChangeText={onChangeText}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            style={{
                backgroundColor: '#ffebae',
                borderWidth: 1.5,
                borderRadius: 25,
                paddingStart: 60,
                height: 35, 
                borderColor: '#f7d97c',
            }}
            // Pass other props
            {...props}
        />
        {value ? (
        <TouchableOpacity
          style={{ position: 'absolute', right: 0, justifyContent: 'center', paddingEnd: 15 }}
          onPress={() => onChangeText('')}
        >
          <Ionicons name="close" size={18} color="#653463" />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

export default CustomSearchBar;